import type { InspectionLastHistory } from '@/types/deviceReport.types';
import * as styled from '@/components/inspectionHistory/LastEditedHistory/style';
import LastEditedHistoryText from './LastEditedHistoryText';

const LastEditedHistory = ({
  workerName,
  updatedAt,
  inspectionTime,
}: InspectionLastHistory) => {
  return (
    <>
      {workerName && updatedAt && (
        <styled.LastHistoryWrapper>
          <styled.LastHistoryLabel>마지막 수정</styled.LastHistoryLabel>
          <span> | </span>
          <LastEditedHistoryText
            workerName={workerName}
            updatedAt={updatedAt}
            inspectionTime={inspectionTime}
          />
        </styled.LastHistoryWrapper>
      )}
    </>
  );
};

export default LastEditedHistory;
